<template>
  <Base icon="mdi-cake-variant" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ requirement.negative ? '&lt;' : '&#8805;' }}
      {{ requirement.value }} yrs old
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} be
      {{ requirement.negative ? 'less than' : 'at least' }}
      {{ requirement.value }} years old
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
